const configId = (index) => `config-${index}`
export default configId